import Vue from "vue";
import * as moment from "moment";

import { Component, Prop } from "vue-property-decorator";
import { ApiServices } from "../../scripts/ah.mb.model-command-log-services";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

type JobsToShow = "active" | "complete";

@Component
export default class ModelCommandLog extends Vue {

    @Prop()
    modelId: string;

    @Prop()
    scenarioName: string;

    logServices = new ApiServices();


    // Create convergenceServices
    private commandLogServices = new ApiServices();

private mainTable = null;

isVisible: boolean = false;

// Selected jobs
    private selectedLogId = null;

    activeTab: "active" | "complete" = "active";

    jobsToShow: JobsToShow = "active";

//$('[data-toggle="tooltip"]').tooltip({ trigger: 'click' });

//// Setup tooltips
//$('body')
//    .tooltip({
//        //trigger: 'click',
//        trigger: 'hover',
//        container: '#tableDiv',
//        selector: '[title]',
//        delay: { "show": 500, "hide": 5000 },
//        placement: "bottom"
//    });

    beforeRouteLeave(to, from, next) {
        this.isVisible = false;
        next();
    }

// Report table drawer
    populateTable(ident: JobsToShow ) {
    //if (scriptIds.length > 0)
    {

            const ajax = this.getTableAjax(this.modelId, this.scenarioName);


        // Because mvc datatables expects variables in the old format we have to set
        // it to specifically use the old variables, because we are using ajax option below
        //$.fn.dataTable.ext.legacy.ajax = true;

            const columnDefs: DataTables.ColumnSettings[] = [
                {
                    title: "Date",
                    data: "dateExecuted",
                    width: "20%",
                    render: (data) => {
                        var dateStr = data;

                        // Date comes in some non standard format because of datatables
                        // MVC thing
                        var date = moment.utc(dateStr).local().format("dddd, MMMM Do h:mm a");
                        return date;
                    }


                },
                {
                    title: "User",
                    data: "executingUser",
                    width: "8%"
                },
                {
                    title: "Comment",
                    data: "description",
                    //    width: "38%"
                },
                {
                    title: "Options",
                    width: "5%",
                    orderable: false,
                    render: (data, type, oObj) => {
                        
//                        var detailsBtn = `<button class="btn btn-sm btn-default annotation-info-button" data-objectId="${oObj.id}">Details</button>`;
                    var deleteBtn =    `<button class="btn btn-sm btn-danger delete-annotation-button" data-objectId="${oObj.id}">Delete</button>`;

                        return '<div class="btn-toolbar pull-right">' +  deleteBtn;  + '</div>';
                    }

                }
            ];


        const tableSettings: DataTables.Settings = {
            processing: false,
            serverSide: true,
            ajax: ajax,
            //{
                
            //    method: "post",
            //    url: tableUrl,
            //    global: false
            //},
            //serverMethod: "POST",
            autoWidth: false,
            paging: true,
            pageLength: 10,
            //filter: true,
            searching: false,
            stateSave: false,
            order: [[1, "desc"]],

            // Move search box to top left:
            //sDom: "flrtip",

            // Draw callback, for attaching button handlers
            drawCallback: oSettings =>  { this.jobTableDrawCallback(oSettings); },

            // Row callback, for enabling/disabling buttons
            rowCallback: (row, data) => { this.mainTableRowCallback(row, data); },

            // Custom no data message
            language: {
                "emptyTable": "No convergence jobs found"
            },

            columns: columnDefs

        };


        this.mainTable = $("#commandLogTable").DataTable(tableSettings);

            $("#commandLogTable tbody").off("click");

        // Report table Row click handler
        $("#commandLogTable tbody").on("click",
            "tr",
             (e) => {
                var rowData = this.mainTable.row(e.currentTarget).data();
                var id = rowData.id;

                if (this.selectedLogId) {
                    if (this.selectedLogId === id)
                        this.selectedLogId = null;
                    else
                        this.selectedLogId = id;
                } else {

                    this.selectedLogId = id;
                }

                // Update selected row
                $("table tr").removeClass("selected");

                if (this.selectedLogId)
                    $(e).addClass("selected");

            });
    }
};


    mounted() {


        this.isVisible  = true;
        this.populateTable("active");
}

    // Job table draw callback
    jobTableDrawCallback(oSettings) {
            $(".delete-annotation-button").click(this.deleteAnnotationButtonClick);


    //    $(".annotation-info-button").click(e => {
    //        var changeId = $(e.currentTarget).attr("data-objectId");

    //        FetchWrapper.fetch(
    //            `/api/1.0/query/getCommandLogEntry?modelId=${this.modelId}&commandId=${changeId}`,
    //            { method: "get" })
    //            .then(change => change.json())
    //            .then(change => {
    //                let message = change.command.successResponse;
    //                if (change.subjects)
    //                    message = message + "<br><br>" + change.subjects.join("br");
    //                bootbox.alert(message)
    //            });

    //});

    };

    /**
* Delete annotation button click
*/
    deleteAnnotationButtonClick(e) {
        bootbox.confirm2("Delete command?<br><br>AIDS")
            .then(() => {const id = $(e.target).attr("data-objectId");
                this.logServices.deleteAnnotation(this.modelId, id)
                    .then(() => { this.refreshTable() });
            });

    }


// Job table row callback
 mainTableRowCallback(row, data) {
     if (this.selectedLogId && data[0] === this.selectedLogId) {
        $(row).addClass("selected");
    }
};


    refreshTableClick() {
        this.refreshTable();
}

// Refreshes the script list
 refreshTable() {

     this.mainTable.ajax.url(this.getTableAjaxUrl(this.modelId, this.scenarioName)).load();
}

    tabChanged(jobsToShow: JobsToShow) {
        this.jobsToShow = jobsToShow;
        this.mainTable.ajax.url(this.getTableAjaxUrl(this.modelId, this.scenarioName)).load();

//        this.populateTable(ident);
    }

    getTableAjaxUrl(modelId: string, scenarioName: string): string {

        const tableUrl = `/ModelChangeLog/${this.modelId}/asdatatable`;
        return tableUrl;
    }


    getTableAjax(modelId: string, scenarioName: string): DataTables.AjaxSettings{
        return {
            method: "POST",
            url: this.getTableAjaxUrl(modelId, scenarioName),
            global: false

        };


    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/model-command-log/model-command-log.ts